export enum QueryParams {
  Supplier = 'supplier',
  Client = 'client',
}
